import React from 'react'
import type { ViewProps } from 'react-native'
import { View } from 'react-native'

import { separator } from '@ui-kit/components/layoutComponents/Separator/styles'
import { borderColor } from '@ui-kit/styles/colors'
import { paddingY } from '@ui-kit/styles/padding'

import type { SeparatorProps } from './types'

const Separator = (props: SeparatorProps & { style?: ViewProps['style'] }) => {
  const { container, line } = separator({
    lineType: props.lineType,
  })
  return (
    <View
      className={container({
        className: paddingY({ space: props.space ?? 'medium' }),
      })}
    >
      <View
        className={line({
          className: borderColor({ color: props.color }),
        })}
      />
    </View>
  )
}

export default Separator
